import React from 'react';
import PropTypes from 'prop-types';
import { Notification } from '@telus-uds/components-web';
import RichText from '../richText';

const ErrorMessage = ({ type = 'text', text = '', data, options = { renderMark: {}, renderNode: {} } }) => {
  return (
    <div style={{ margin: '1em 0' }}>
      <Notification variant={{ validation: 'error' }}>
        {type === 'richText' ? (
          <RichText data={data} options={options} />
        ) : (
          // UDS Notification sets an inline `line-height: 1.5px` (theme-allium's `1.5`
          // multiplier token misinterpreted as a literal pixel value by react-native-web),
          // which shrinks the inherited line box and visually misaligns the text against
          // the Notification's own icon - override it directly on our text.
          <p style={{ lineHeight: '24px' }}>{text}</p>
        )}
      </Notification>
    </div>
  );
};

ErrorMessage.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  data: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.object).isRequired
  }),
  options: PropTypes.shape({
    renderMark: PropTypes.object,
    renderNode: PropTypes.object
  })
};

export default ErrorMessage;
